import { ApiRoutes } from '../helpers/routes'
import { RequestEditJobPostDTO, RequestJobPostDTO, Salary, SimpleJobPostDTO } from '../models/post'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/jobPosts`

class JobService {
    getJobPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.jobPosts.getAll}`, {
            method: 'GET',
        })
    }

    getRecommendedPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.jobPosts.recommended}`, {
            method: 'GET',
        })
    }

    getMyJobPosts = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.jobPosts.me}`, {
            method: 'GET',
        })
    }

    createJobPost = async (post: SimpleJobPostDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.jobPosts.create}`, {
            method: 'POST',
            body: JSON.stringify(new RequestJobPostDTO(post)),
        })
    }

    editJobPost = async (postId: string, post: SimpleJobPostDTO) => {
        return fetchApi(`${baseUrl}/${postId}`, {
            method: 'PUT',
            body: JSON.stringify(new RequestEditJobPostDTO(post)),
        })
    }

    deleteJobPost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}`, {
            method: 'DELETE',
        })
    }

    finishJobPost = async (postId: string) => {
        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.jobPosts.expiration}`, {
            method: 'POST',
        })
    }

    postulateJob = async (postId: string, files: { profile: File; cv: File }, salary: Salary) => {
        const formData = new FormData()
        formData.append('cv', files.cv)
        formData.append('profile', files.profile)
        formData.append('salaryAmount', salary.amount ? salary.amount.toString() : '0')
        formData.append('salaryCurrency', salary.currency)
        formData.append('salaryPeriod', salary.period)
        formData.append('salaryFrequency', salary.frequency)

        return fetchApi(`${baseUrl}/${postId}${ApiRoutes.jobPosts.candidates}`, {
            method: 'POST',
            body: formData,
        })
    }

    deletePostulate = async (postId: string) => {
        return fetchApi(
            `${baseUrl}/${postId}${ApiRoutes.jobPosts.candidates}${ApiRoutes.jobPosts.me}`,
            {
                method: 'DELETE',
            },
        )
    }
}

export default JobService
